export enum ClassifiedReportReason {
  OTHER = 7
}
